import React from 'react';
import { createOrganizationApplicationTemplate } from '~/javascripts/admin/actions/merchant-application-templates';
import { useAppSelector } from '~/javascripts/admin/hooks/useApp';
import Headings from '../../atoms/Headings';
import BreadCrumb from '../../molecules/BreadCrumb';
import EditMerchantApplicationTemplate, {
  MerchantApplicationTemplateValues,
} from '../EditMerchantApplicationTemplate';

const CRUMBS = [
  { value: 'ホーム', href: '/', isCurrentPage: false },
  { value: '決済加盟店管理', href: '', isCurrentPage: true },
  { value: '加盟店申込フォーム', href: '/organizations/application-form', isCurrentPage: false },
  { value: '加盟店申込フォーム新規作成', href: '', isCurrentPage: true },
];

const CreateMerchantApplicationTemplate = () => {
  const user = useAppSelector((state) => state.user);

  const onConfirm = async (formValues: MerchantApplicationTemplateValues) => {
    const params = {
      title: formValues.title,
      status: formValues.status,
      application_term_url: formValues.application_term_url || null,
      redirect_url: formValues.redirect_url || null,
      private_money_ids: formValues.private_money_ids,
      capital_field_option: formValues.capital_field_option,
      number_of_employees_field_option: formValues.number_of_employees_field_option,
      referral_source_field_option: formValues.referral_source_field_option,
      description: formValues.description,
      issuer_organization_code: user.organization?.code,
      user_tag_group_options: formValues.user_tag_group_options,
    };

    const result = await createOrganizationApplicationTemplate(params);
    return { id: result.id };
  };

  return (
    <>
      <BreadCrumb crumbs={CRUMBS} />
      <Headings.h5>加盟店申込フォーム新規作成</Headings.h5>
      <EditMerchantApplicationTemplate mode="create" onConfirm={onConfirm} />
    </>
  );
};

export default CreateMerchantApplicationTemplate;
